import {
  Alert,
  AlertIcon,
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
} from '@elkaso-app/web-design';
import React from 'react';
import { FiAlertTriangle, FiTrash2 } from 'react-icons/fi';

interface DeleteConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  itemName: string;
  isLoading?: boolean;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  itemName,
  isLoading = false,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size='md'>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <HStack spacing={2}>
            <FiTrash2 color='#E53E3E' />
            <Text>Delete Brand Location</Text>
          </HStack>
        </ModalHeader>
        <ModalCloseButton />

        <ModalBody>
          <VStack spacing={4} align='stretch'>
            <Alert status='warning' borderRadius='md'>
              <AlertIcon />
              <VStack align='start' spacing={2}>
                <Text fontWeight='semibold'>This action cannot be undone</Text>
                <Text fontSize='sm'>
                  This will permanently delete the brand location and remove all associated data.
                </Text>
              </VStack>
            </Alert>

            <VStack spacing={3} align='start'>
              <Text>Are you sure you want to delete the following location?</Text>

              <HStack spacing={2} p={3} bg='red.50' borderRadius='md' w='full'>
                <FiAlertTriangle color='#E53E3E' />
                <Text fontWeight='semibold' color='red.700'>
                  {itemName}
                </Text>
              </HStack>

              <Text fontSize='sm' color='gray.600'>
                All data associated with this location will be permanently removed from the system.
              </Text>
            </VStack>
          </VStack>
        </ModalBody>

        <ModalFooter>
          <HStack spacing={3}>
            <Button variant='outline' onClick={onClose} isDisabled={isLoading}>
              Cancel
            </Button>
            <Button colorScheme='red' onClick={onConfirm} isLoading={isLoading} loadingText='Deleting...'>
              Delete Location
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeleteConfirmationModal;
